import { REGIONS } from '#app/utils/search-lib'

/**
 * Läser regionen ur URL:en för chatten. Okända värden ignoreras i stället för
 * att skickas vidare och ge 400 på varje fråga.
 *
 * Motorvalet (?engine=) läses inte längre: egen motor svarar alltid sedan IM-60,
 * så ett gammalt ?engine= i en pilotlänk eller ett bokmärke gör ingenting.
 * Regionvalet visas därmed alltid som riktig funktion på startsidan.
 */
export interface ChatControlsState {
	/** 'all' = ingen region vald (skickas inte). Okänt värde → 'all', så en
	 * skräp-URL aldrig ger 400 "Ogiltig region." på varje fråga. */
	region: string
}

export function resolveChatControls(
	params: URLSearchParams,
): ChatControlsState {
	const rawRegion = params.get('region')
	const region = REGIONS.some(r => r.value === rawRegion)
		? (rawRegion as string)
		: 'all'
	return { region }
}
